export interface Season_data {
    imgurl : string;
}

let season_data:Season_data[] = [
    {
        imgurl : './img/season/img0.jpg'
    },
    {
        imgurl : './img/season/img1.jpg'
    },
    {
        imgurl : './img/season/img2.jpg'
    },
    {
        imgurl : './img/season/img3.jpg'
    },
    {
        imgurl : './img/season/img4.jpg'
    },
    {
        imgurl : './img/season/img5.jpg'
    },
    {
        imgurl : './img/season/img6.jpg'
    },
    {
        imgurl : './img/season/img7.jpg'
    },
    {
        imgurl : './img/season/img8.jpg'
    },
    {
        imgurl : './img/season/img9.jpg'
    },
    {
        imgurl : './img/season/img10.jpg'
    },
    {
        imgurl : './img/season/img11.jpg'
    },
    {
        imgurl : './img/season/img12.jpg'
    },
    {
        imgurl : './img/season/img13.jpg'
    },
    {
        imgurl : './img/season/img14.jpg'
    }
]

export default season_data;